export interface MentionQuery {
  start: number;
  end: number;
  query: string;
}

const openMention = /@([^\s@]*)$/u;
const canonicalMention = /^@(图片|视频|音频)[1-9]\d*$/u;

export function mentionQueryAtCaret(
  prompt: string,
  caret: number
): MentionQuery | undefined {
  const safeCaret = Math.max(0, Math.min(caret, prompt.length));
  const match = prompt.slice(0, safeCaret).match(openMention);
  if (match === null || canonicalMention.test(match[0])) return undefined;
  return {
    start: safeCaret - match[0].length,
    end: safeCaret,
    query: match[1] ?? ""
  };
}

export function replaceMentionQuery(
  prompt: string,
  query: MentionQuery,
  mention: string
): string {
  return `${prompt.slice(0, query.start)}${mention}${prompt.slice(query.end)}`;
}
